/**
 * MM Header Texte - Moon Moon Agency
 * Troncature du paragraphe avec bouton « Lire plus »
 */

/*********************************************************************************************
 * 📖 HEADER TEXTE READ MORE MANAGER
 * Le clamp est fait en CSS (`--mm-header-texte-lines`, pose par le setting du
 * block) ; ce module ne fait que reveler le bouton lorsque le texte deborde
 * reellement, et basculer l'etat deplie.
 *
 * Meme mecanique que `ProductReadMoreManager` (mm_main_product.js), duplique
 * ici parce que ce dernier n'est charge que par la section produit, alors que
 * `MM-Header-Texte` peut etre posee sur n'importe quelle page.
 */
const HeaderTexteReadMoreManager = {
	config: {
		selectors: {
			wrapper: '[data-mm-readmore]',
			text: '[data-mm-readmore-text]',
			toggle: '[data-mm-readmore-toggle]',
		},
		classes: {
			expanded: 'is-expanded',
			hidden: 'mm-none',
		},
	},

	init() {
		const wrappers = window.getElements(this.config.selectors.wrapper);
		if (!wrappers.length) return;

		wrappers.forEach((wrapper) => this._setup(wrapper));
		this._bindEvents();

		window.log('info', '📖 [HEADER_TEXTE]', 'Initialized', { count: wrappers.length });
	},

	/**
	 * Revele le bouton uniquement si le texte est effectivement tronque.
	 * Re-teste au redimensionnement : un texte tronque en mobile peut tenir
	 * sur le nombre de lignes autorise en desktop.
	 */
	_setup(wrapper) {
		const text = wrapper.querySelector(this.config.selectors.text);
		const toggle = wrapper.querySelector(this.config.selectors.toggle);
		if (!text || !toggle) return;

		const refresh = () => {
			// Une fois deplie, le texte ne deborde plus : le bouton doit rester
			// visible pour permettre de replier.
			if (wrapper.classList.contains(this.config.classes.expanded)) return;

			const isTruncated = text.scrollHeight > text.clientHeight + 1;
			toggle.classList.toggle(this.config.classes.hidden, !isTruncated);
		};

		refresh();

		if (typeof ResizeObserver !== 'undefined') {
			const observer = new ResizeObserver(() => refresh());
			observer.observe(text);
		}
	},

	_bindEvents() {
		document.addEventListener('click', (e) => {
			const toggle = e.target.closest(this.config.selectors.toggle);
			if (!toggle) return;

			const wrapper = toggle.closest(this.config.selectors.wrapper);
			if (!wrapper) return;

			const isExpanded = wrapper.classList.toggle(this.config.classes.expanded);
			toggle.setAttribute('aria-expanded', String(isExpanded));

			const label = isExpanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
			if (label) toggle.textContent = label;
		});
	},
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => HeaderTexteReadMoreManager.init());
} else {
	HeaderTexteReadMoreManager.init();
}
